'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import { getHubSpotUserId } from 'AdsUI/selectors/AuthSelectors';
import { getRequestStatus } from 'AdsUI/selectors/RequestStatusSelectors';
import { CouponBanner } from 'AdsUI/components/Banners';
import { fetchAdsUserAttributes } from 'AdsUI/actions/UserAttributesActions';
import { getCouponBannerHiddenStatus } from 'AdsUI/selectors/UserAttributesSelectors';
import { saveCouponBannerHiddenForUser } from 'AdsUI/actions/UserAttributesActions';
import { getPortalShouldSeeCouponBanner } from 'AdsUI/selectors/HubAttributesSelectors';
import HubAttributesActions from 'AdsUI/actions/HubAttributesActions';
import { usageTracker } from 'AdsUI/lib/usageTracker';

const CouponBannerWrapper = ({
  couponBannerHidden,
  dispatch,
  portalShouldSeeBanner,
  userId,
  userAttributesRequestStatus
}) => {
  useEffect(() => dispatch(HubAttributesActions.fetch()), [dispatch]);
  useEffect(() => dispatch(fetchAdsUserAttributes(userId)), [dispatch, userId]);
  const handleHide = useCallback(() => {
    dispatch(saveCouponBannerHiddenForUser(userId));
    usageTracker.track('couponAction', {
      action: 'Dismissed banner'
    });
  }, [dispatch, userId]);
  const hideBanner = portalShouldSeeBanner === 'false' || !userAttributesRequestStatus.fetchedSuccessfully() || couponBannerHidden !== 'false';
  useEffect(() => {
    if (hideBanner) {
      return;
    }

    usageTracker.track('couponAction', {
      action: 'Displayed banner'
    });
  }, [hideBanner]);

  if (hideBanner) {
    return null;
  }

  return /*#__PURE__*/_jsx(CouponBanner, {
    onHide: handleHide
  });
};

export default connect(state => ({
  userId: getHubSpotUserId(state),
  couponBannerHidden: getCouponBannerHiddenStatus(state),
  userAttributesRequestStatus: getRequestStatus('userAttributes')(state),
  portalShouldSeeBanner: getPortalShouldSeeCouponBanner(state)
}))(CouponBannerWrapper);